









import Vue from 'vue'

export default Vue.extend({
    name: 'Pagination',
    props: [ 'casesNum' ],
    data(){
        return { currentCase:0, nextCase:0, prevCase:0 }
    },
    created(){
        this.currentCase = parseInt(this.$route.params.caseId)
        this.setLinks(this.currentCase)
    },
    methods: {
        setLinks(n:number){
            this.prevCase = (this.currentCase - 1 > 0)
                ? n - 1
                : this.casesNum
            this.nextCase = (this.currentCase + 1 <= this.casesNum)
                ? n + 1
                : 1
        }
    }
})
